
    import I18n from 'i18nObj';
    
      import 'translations/assignments.create_group';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('assignments.create_group');
  